<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="municipio_ini"
                        :options="this.$parent.optionsMunicipio"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Município Origem"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="municipio_fim"
                        :options="this.$parent.optionsMunicipio"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Município Destino"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="regiao_ini"
                        :options="this.$parent.optionsRegiao"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Região Origem"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="regiao_fim"
                        :options="this.$parent.optionsRegiao"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Região Destino"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="tp_operacao"
                        :options="this.$parent.optionsTpOperacao"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo da Operação"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="status"
                        :options="this.$parent.optionsStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="" md="3" class="m-t-5px p-a-0">
                        <multiselect
                        v-model="transportadora"
                        :options-limit="300"
                        :limit="2"
                        :limit-text="limitText"
                        :options="optionsTransportadora"
                        track-by="value"
                        label="label"
                        id="transportadora"
                        :hide-selected="true"
                        placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        :searchable="true"
                        :loading="isLoadingTransportadora"
                        @search-change="listaTransportadora"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                      <div class="input-group-btn">
                        <div class="btn-group">
                          <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                          <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                        </div>
                      </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
        isLoadingTransportadora: false,
        transportadora: [],
        optionsTransportadora: [],
        optionsMunicipio: [],
        optionsTpOperacao: [],
        optionsStatus: [],
        municipio_ini: [], 
        municipio_fim: [],
        regiao_ini: [],
        regiao_fim: [],
        tp_operacao: [],
        status: [],
        data_filter: [],
        helpForm: new Form({statusRecord: [], params: [], search: ''}),
    }
  },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {municipio_ini: this.municipio_ini,
                              municipio_fim: this.municipio_fim,
                              regiao_ini: this.regiao_ini,
                              regiao_fim: this.regiao_fim,
                              tp_operacao: this.tp_operacao,
                              status: this.status,
                              transportadora: this.transportadora,}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.municipio_ini = '';  // clear the text in text input
        this.municipio_fim= '';
        this.regiao_ini = '';
        this.regiao_fim = '';
        this.tp_operacao = '';
        this.status = '';
        this.transportadora = '';
        this.$events.fire('filter-reset');
      },
        listaTransportadora(search) {
        if (search.length >= 3) {
            this.isLoadingTransportadora = true;
            this.helpForm.search = search;
            this.helpForm.status = 1;
            this.helpForm
            .post("/api/pessoa/jsonlist/transportadora")
            .then((response) => {
                this.optionsTransportadora = [];
                new ReturnApi(response, this, true, false, false);
                if (response.items.length > 0) {
                response.items.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PJ -" + obj.pessoa.cd + " - " + obj.razao_social + " - " + this.onFormataCnpj( obj.cnpj_base, obj.cnpj_filial, obj.cnpj_digito).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") + " - " + obj.inscricao_estadual, pessoa_id: obj.pessoa_id, value: obj.pessoa_id,
                    });
                });
                }
                if (response.itemsF.length > 0) {
                response.itemsF.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PF -" + obj.nome + " - " + obj.cpf,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                    });
                });
                }
                if (response.itemsE.length > 0) {
                response.itemsE.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PE -" + obj.nome + " - " + obj.cd,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                    });
                });
                }
                this.isLoadingTransportadora = false;
            })
            .catch((errors) => {
                new ReturnApi(errors, this);
            });
        }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        var cnpj_formatado
        var pad = "00000000";
        var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
        var pad = "0000"
        var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
        var pad = "00"
        var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
        return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
  },
  computed: {
      vuetableFilterButton: {
          get () {
              return this.$store.state.vuetable.filterButton;
          },
      },
  }
}
</script>
